import React from 'react'
import PropTypes from 'prop-types'
import { Link } from "react-router-dom";


export default function Header(props) {
  return (
    <>
      <header className=''>
        <div className="header-main">
            <div className="container-fluid">  

            <nav className="navbar navbar-expand-lg ">
  <div className="container-fluid">
    {/* Logo */}
    <div className="header-logo hidden-logo">
      <a href="/">
        <img src="/assets/images/logo/logo1.png" alt="magma" className="site_logo" />
      </a>
    </div>

    {/* Push menu to the right */}
    <div className="d-flex ms-auto">
      {/* Navbar Toggler (Mobile Menu) */}
      <button
        className="navbar-toggler"
        type="button"
        data-bs-toggle="offcanvas"
        data-bs-target="#mobileMenu"
        aria-controls="mobileMenu"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span className="navbar-toggler-icon"></span>
      </button>

      {/* Offcanvas Sidebar for Mobile Menu (Opens from Right) */}
      <div  className="offcanvas offcanvas-end"  tabIndex="-1" id="mobileMenu" aria-labelledby="mobileMenuLabel" style={{ width: '62vw' }}>
        <div className="offcanvas-header">
          {/* <h5 id="mobileMenuLabel">Menu</h5>   */}
          <button type="button" className="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
        </div>
        <div className="offcanvas-body">
          <ul className="navbar-nav ms-auto" > {/* Keep menu aligned to the right */}
            <li className="nav-item text-uppercase">
              <Link className="nav-link active" to="/">Employee Dining</Link>
            </li>
            <li className="nav-item text-uppercase">
              <Link className="nav-link" to="/conference-menu">Catering Menu</Link>
            </li>

            <li className="nav-item text-uppercase">
              <Link className="nav-link" to="/work-cafes">Work Cafe</Link>
            </li>
          
            <li className="nav-item text-uppercase">
              <Link className="nav-link" to="/sustainability">Sustainability</Link>
            </li>
            <li className="nav-item text-uppercase">
              <Link className="nav-link" to="/healthy-recipes">Healthy Recepies</Link>
            </li>
           
            <li className="nav-item dropdown text-uppercase">
              <a className="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                Updates
              </a>
              <ul className="dropdown-menu">
                <li><Link className="dropdown-item" to="/allergens">Allergens</Link></li>
                <li><Link className="dropdown-item" to="/disclaimer">Disclaimer</Link></li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div className="header-logo hidden-laptop">
      <a href="/" className='mobile_logo-res'>
        <img src="/assets/images/logo/logo1.png" alt="magma" className="site_logo" />
      </a>
    </div>

  </div>
</nav>





            </div>
        </div>
      </header>
    </>
  );
};
